import { connect } from 'react-redux';
import { ROUTE_FAN_FEED_TAGS_EDIT, ROUTE_FAN_FEED_TAGS_NEW }from '../constants';
import actions from '../../../actions/fan_feed/fan_feed_tags';
import {getCurrentClubId} from '../../../selectors/club-settings';
import {listStateFromCRUD, listDispatchFromCrud} from '../../../selectors/crud';
import { push } from 'react-router-redux/lib/actions';
import { setHeaderTitle } from '../../../actions/layout';
import FanFeedTagsList from './FanFeedTagsList';

export default connect(
  (state) => ({
    headerTitle: 'FanFeed Tags',
    ...listStateFromCRUD(state.fan_feed_tags),
    filter: {
      club_id: getCurrentClubId(state)
    }
  }),
  (dispatch) => {
    return {
      updateHeaderTitle: (title) => dispatch(setHeaderTitle(title)),
      ...listDispatchFromCrud(dispatch, actions),
      edit: (id) => dispatch(push(ROUTE_FAN_FEED_TAGS_EDIT.replace(':id', id))),
      add: () => dispatch(push(ROUTE_FAN_FEED_TAGS_NEW))
    };
  }
)(FanFeedTagsList);



// WEBPACK FOOTER //
// ./src/components/FanFeed/FanFeedTagsList/index.ts